import {
  Box,
  Flex,
  Button,
  Heading,
  Text,
  useToast,
  Icon,
} from '@chakra-ui/react';
import { useSamples } from '../../api/projectApi';
import { useParams, useLocation } from 'react-router-dom';
import { FaUpload } from 'react-icons/fa';
import SampleTable from '../../components/sample/SampleTable';

const SamplePage = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const location = useLocation(); // Get state from navigation
  const toast = useToast();

  // Extract project name from state if available, otherwise use default
  const projectName = location.state?.projectName || `Project ${projectId}`;

  const { samples, isLoading, error, refetch } = useSamples(projectId || '');

  const handleUploadSample = () => {
    toast({
      title: 'Upload Sample',
      description: 'Sample upload functionality to be implemented',
      status: 'info',
      duration: 3000,
      isClosable: true,
    });
  };

  if (isLoading) {
    return (
      <Box maxW="container.xl" mx="auto" py={8} px={4}>
        <Text>Loading...</Text>
      </Box>
    );
  }

  if (error) {
    return (
      <Box maxW="container.xl" mx="auto" py={8} px={4}>
        <Text color="red.500">{error}</Text>
      </Box>
    );
  }

  return (
    <Box maxW="container.lg" mx="auto" py={8} px={4}>
      <Flex
        justify="space-between"
        align="center"
        mb={6}
        direction={{ base: 'column', md: 'row' }}
        gap={4}
      >
        <Box>
          <Heading size="lg" color="primary.500" mb={1}>
            {projectName} {/* Display Correct Project Name */}
          </Heading>
        </Box>

        <Button
          size="md"
          onClick={handleUploadSample}
          px={6}
          leftIcon={<Icon as={FaUpload} />}
          color="white"
          border="1px"
          borderColor="surface.300"
          borderRadius="md"
          _hover={{ bg: 'secondary.500' }}
          bg="#1a1262"
        >
          Upload Sample
        </Button>
      </Flex>

      {samples.length === 0 ? (
        <Box
          textAlign="center"
          py={10}
          bg="surface.200"
          borderRadius="xl"
          border="1px dashed"
          borderColor="surface.300"
        >
          <Text color="muted.400">
            No samples found. Click the Upload Sample button to add samples.
          </Text>
        </Box>
      ) : (
        <Box bg="white" borderRadius="xl" overflow="hidden" boxShadow="sm">
          <SampleTable samples={samples} onRefresh={refetch} />
        </Box>
      )}
    </Box>
  );
};

export default SamplePage;
